import { Stack, Typography } from "@mui/material";
import AutoComplete from "../client-information/auto-complete";
import { MdaClientOption } from "./mda-types";

interface MdaClientFilterProps {
  clients: MdaClientOption[];
  selectedClient: string;
  onChange: (client: string) => void;
}

const MdaClientFilter = ({
  clients,
  selectedClient,
  onChange,
}: MdaClientFilterProps) => (
  <Stack spacing={0.8}>
    <Typography variant="caption" sx={{ color: "#24344d", fontWeight: 700 }}>
      Client Name
    </Typography>
    <AutoComplete
      label=""
      suggestions={clients}
      selectedValue={
        clients.find((client) => client.name === selectedClient) ?? null
      }
      onChange={(value: MdaClientOption | null) => onChange(value?.name ?? "")}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          minHeight: 32,
          py: 0,
        },
        "& .MuiAutocomplete-input": {
          py: "4px !important",
        },
      }}
    />
  </Stack>
);

export default MdaClientFilter;
